export default __webpack_public_path__ + "transfix-maps/icons/D-newWave.c2fc915f128a6c8fdb53a6e3e6d4424c.png";